import api from "../../../api/axios";
import {
  trackLead,
  captureAdAttribution,
  getStoredAdAttribution,
} from "../../../utils/tracking";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSpinner } from "../../../context/Spinner";
import { useState } from "react";

const useCreateFreeQuoteMutation = () => {
  const spinner = useSpinner();
  const [isCreating, setIsCreating] = useState(false);

  return useMutation(
    async ({
      name,
      email,
      whatsapp,
      projectType,
      title,
      notes,
      images,
    }) => {
      setIsCreating(true);
      spinner.setLoadingState(true);

      const formData = new FormData();

      formData.append("name", name);
      formData.append("email", email);
      formData.append("whatsapp", whatsapp || "");
      formData.append("projectType", projectType || "");
      formData.append("title", title || "Free Quote Request");
      formData.append("notes", notes);

      // Capture the click identifiers from the current landing URL and
      // attach the stored attribution to the lead before it leaves the browser.
      captureAdAttribution();
      const attribution = getStoredAdAttribution();

      [
        "gclid",
        "gbraid",
        "wbraid",
        "utmSource",
        "utmMedium",
        "utmCampaign",
        "utmTerm",
        "utmContent",
      ].forEach((key) => {
        if (attribution?.[key]) {
          formData.append(key, attribution[key]);
        }
      });

      if (images) {
        for (let i = 0; i < images.length; i++) {
          formData.append("images", images[i]);
        }
      }

      const response = await api.post("/free-quote/create", formData);

console.log("Free quote response:", response);

// Google Ads + Meta Lead conversion
trackLead({
  lead_type: "free_quote",
  project_type: projectType || "",
  quote_title: title || "Free Quote Request",
  value: 1.0,
  currency: "INR",
});

toast.success("Your free quote request has been sent successfully.", {
  toastId: "free-quote-success",
});

return response.data;
    },
    {
      onSuccess: () => {
        setIsCreating(false);
        spinner.setLoadingState(false);
        console.log("Free quote created successfully");
      },

      onError: (error) => {
        setIsCreating(false);
        spinner.setLoadingState(false);

        if (error.response) {
          const status = error.response.status;

          if (status === 413) {
            toast.error("Image size exceeds the 16 MB limit", {
              toastId: "free-quote-error",
            });
          } else {
            toast.error(`Server error: ${status}`, {
              toastId: "free-quote-error",
            });
          }
        } else if (error.request) {
          toast.error("No response from the server", {
            toastId: "free-quote-error",
          });
        } else {
          toast.error("An unexpected error occurred", {
            toastId: "free-quote-error",
          });
        }
      },

      onSettled: () => {
        setIsCreating(false);
      },
    }
  );
};

export default useCreateFreeQuoteMutation;